import Controller from '../abstracts/Controller';
import 'scss-templates/t-newsletter.scss';

export default class NewsletterPageController extends Controller {
  static get COMPONENTS() {
    return [
      'NewsletterComponent',
    ];
  }
}
